import { MdAutorenew } from 'react-icons/md';
import { Icon, Pill, PillProps } from '@nbirl/nbi-common-ui-libs';

import { DocumentStatus } from '../models';
import { DocumentStatusLabel } from './document-status-label.component';

const getVariant = (status: DocumentStatus): PillProps['variant'] => {
  switch (status) {
    case 'PUBLISHED':
      return 'emerald';
    case 'REJECTED':
      return 'red';
    case 'PENDING':
      return 'orange';
  }
};

export type DocumentStatusPillProps = {
  status: DocumentStatus;
  isUpdating?: boolean;
} & Omit<PillProps, 'variant'>;

export const DocumentStatusPill = ({
  status,
  isUpdating,
  ...rest
}: DocumentStatusPillProps) =>
  isUpdating ? (
    <Pill variant="gray" {...rest}>
      <div className="flex items-center justify-center">
        <Icon size="16" icon={<MdAutorenew className="animate-spin mr-1" />} />
        Updating
      </div>
    </Pill>
  ) : (
    <Pill variant={getVariant(status)} {...rest}>
      <DocumentStatusLabel status={status} />
    </Pill>
  );
